const PROPRIETARY_SECTION_MARKERS = [
  '\n## Pattern Requirements',
  '\n## Color Palette Specifications',
  '\n## Pattern Architecture',
  '\n## Layering Instructions',
  '\n## Shape Scale Distribution',
  '\n## Shape Geometry Instructions',
  '\n## Pattern Density Guidelines',
  '\n## Edge Style Requirements',
  '\n## Depth and Blending Effects',
  '\n## Camouflage Intent',
  '\n# Camouflage Pattern Generation Instructions',
  '\n# Camouflage Pattern Brief',
];

/**
 * Keep only user-facing environment analysis (strip proprietary pattern instructions).
 */
export function sanitizePublicEnvironmentAnalysis(markdown) {
  if (!markdown || typeof markdown !== 'string') {
    return '';
  }

  let cutAt = markdown.length;
  for (const marker of PROPRIETARY_SECTION_MARKERS) {
    const index = markdown.indexOf(marker);
    if (index >= 0 && index < cutAt) {
      cutAt = index;
    }
  }

  return markdown.slice(0, cutAt).trim();
}
